import React from 'react';
import Combobox from './primitives/Combobox';
import { StandardAccounts, StandardAccountModel } from '../../../views/StandardAccounts';
import { useStandardAccounts } from '../../hooks/masterdata/useStandardAccounts';

const isAvailable = (accountTypeNumber: number) => accountTypeNumber === 1 || accountTypeNumber === 2;

export interface StandardAccountComboboxProps {
    onCreated?: Function;
    hideSummary?: boolean;
    [x: string]: any;
}

export default function StandardAccountCombobox({ onCreated, hideSummary = false, ...props }: StandardAccountComboboxProps) {
    const { data: accounts } = useStandardAccounts({
        options: { useCache: props?.useCache },
    });

    function mapAccount(account: StandardAccountModel) {
        return {
            data: account,
            text: `${account.id} - ${account.name}`,
            summary: hideSummary ? undefined : account.name,
            value: account.id,
        };
    }
    return (
        <Combobox
            {...props}
            aria-label={props['aria-label'] ?? `standardaccountcombobox`}
            data={accounts.filter(standardAccount => standardAccount.type && isAvailable(standardAccount.type)).map(mapAccount)}
            modal={({ hide, onChange }) => (
                <StandardAccounts
                    onSelected={account => {
                        onChange(account.id, account);
                        hide();
                    }}
                    selectedAccountNumber={props.value}
                    useCache={props?.useCache}
                />
            )}
            modalSize="sm"
            style={{ width: '150px' }}
        />
    );
}
